import "./TheBeneWealthEdge.module.css";
import VaultHeader from "@/reusable_sections/Header";
import Credibility from "./sections/Credibility";
import Timeline from "./sections/Timeline";
import Trust from "./sections/Trust";
import VaultFooter from "@/reusable_sections/Footer";
export default function TheBeneWealthEdgePage() {
  return <div>
      <VaultHeader />
      <Credibility />
      <Timeline />
      <Trust />
      <VaultFooter />
    </div>;
}